import { useState, useRef } from 'react';
import { sandhillsRequest } from '@Components/Utilities/SandhillsUtility';
import TranslationText from '@Components/Utilities/TranslationText';
import translator from '@Components/Utilities/Translator';
import SimpleHomeBreadcrumb from '@Components/Shared/SimpleHomeBreadcrumb';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';
import { LinkRelationTypes } from '@Components/Utilities/SandhillsConstants';

const NewsstandView = (props) => {

    const [digitalIssues, setDigitalIssues] = useState(props.DigitalIssues);
    const queue = useRef([]);
    const processing = useRef(false);
    const unsubscribeText = translator.getPlainTextPhrase('sandhills.tradepubwebsite.mvc.unsubscribe');
    const subscribeText = translator.getPlainTextPhrase('sandhills.tradepubwebsite.mvc.subscribenow');
    const routes = useRecoilValue(atoms.routes);

    const updateDigitalIssue = (subscription) => {
        setDigitalIssues(previousState => {
            return [...previousState].map(issue => {
                if (issue.DigitalIssue.DigitalIssueID === subscription.DigitalIssue.DigitalIssueID) {
                    return subscription;
                } else {
                    return issue;
                }
            });
        });
    };

    const handleResponse = (response, issue) => {
        if (response.Successful) {
            let sub = { ...issue };
            sub.UserIsSubscribed = !sub.UserIsSubscribed;
            sub.Pending = false;
            updateDigitalIssue(sub);
        }
        processSubscriptionFromQueue();
    };

    const subscribeDigitalIssue = (issue) => {
        sandhillsRequest({
            url: routes.UpdateDigitalEditionsSubscription,
            method: 'post',
            data: {
                bSubscribe: !issue.UserIsSubscribed,
                nSubscriptionID: issue.SubscriptionID
            },
            errorHandling: {
                useConsole: false,
                useAlert: false
            }
        }).then((response) => {
            handleResponse(response, issue);
        });
    };

    const processSubscriptionFromQueue = () => {
        if (queue.current && queue.current.length > 0) {
            let newQueue = [...queue.current];
            let process = newQueue.shift();
            queue.current = newQueue;
            processing.current = true;
            process();
        } else {
            processing.current = false;
        }
    };

    const toggleSubscribe = (issue) => {
        let sub = { ...issue };
        if (sub.Pending) {
            return;
        }
        sub.Pending = true;
        updateDigitalIssue(sub);
        if (processing.current) {
            let process = () => subscribeDigitalIssue(sub);
            if (!queue.current) {
                queue.current = [];
            }
            queue.current = [...queue.current, process];
        } else {
            processing.current = true;
            subscribeDigitalIssue(sub);
        }
    };

    return (
        <div className='newsstand-content'>
            <SimpleHomeBreadcrumb homeRoute={props.BreadCrumbHomeRoute} displayText={props.BreadCrumbText} />
            <div className='inner-wrap main-content'>
                <div>
                    <h1 className='pagename border-bottom'><TranslationText tKey='sandhills.tradepubwebsite.mvc.newsstand' /></h1>
                </div>
                {props.NewsstandSummary &&
                    <p dangerouslySetInnerHTML={{ __html: props.NewsstandSummary }}></p>
                }
                {digitalIssues && digitalIssues.length > 0 && digitalIssues.map(issue =>
                    <div key={issue.DigitalIssue.DigitalIssueID} className='di-container column3'>
                        <div className='di-img-outer'>
                            {issue.RedirectToArchive ?
                                <a href={issue.ArchiveUrl} className='di-img-inner'>
                                    <img src={issue.DigitalIssue.CoverImageURL} className='di-img' alt={issue.DigitalIssue.IssueName + ' ' + translator.translate('sandhills.coverpreview')} />
                                </a>
                                :
                                <a href={issue.DigitalIssue.IssueURL} className='di-image-outer' target='_blank' aria-label={issue.DigitalIssue.IssueName + ' (' + translator.translate('sandhills.opensinanewtab') + ')'}>
                                    <img src={issue.DigitalIssue.CoverImageURL} className='di-img' alt={issue.DigitalIssue.IssueName + ' ' + translator.translate('sandhills.coverpreview')} />
                                </a>}
                        </div>
                        {!issue.ShowOnlyImages &&
                            <div className='di-info'>
                                <div className='di-edition-name'>{issue.ProperEditionName}</div>
                                {(issue.DigitalIssue.IssueName.toLowerCase() !== 'sandhills magazine') &&
                                    <div className='di-region'>{issue.DisplayRegionName}</div>}
                                <div className='di-issue-date'>{issue.DisplayIssueDate}</div>
                            </div>}
                        <div>
                            <a className='di-subscribe' href={issue.ArchiveRegionUrl}><TranslationText tKey='sandhills.tradepubwebsite.mvc.archive' /></a>
                        </div>
                        <div style={{ visibility: !issue.HideSubscriptionButton ? 'visible' : 'hidden'}}>
                            {(props.IsSearchEngine || !props.IsAuthenticated ?
                                <a className='di-subscribe' href={props.RegistrationUrl} rel={LinkRelationTypes.noFollow}> {subscribeText}</a>
                                    :
                                    props.CRMContactID > 0 &&
                                (<a role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleSubscribe(issue); }}} className={issue.UserIsSubscribed ? 'alt di-subscribe' : 'di-subscribe'} onClick={() => toggleSubscribe(issue)}> {issue.UserIsSubscribed ? unsubscribeText : subscribeText}</a>)
                                )}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default NewsstandView;
global.NewsstandView = NewsstandView;